import { signInWithPopup, signOut } from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export const handleGoogleLogin = async (setLoading, setProcessingError) => {
  console.log("Starting Google login...");
  setProcessingError(null);
  setLoading(true);

  try {
    const result = await signInWithPopup(auth, googleProvider);
    console.log("✅ Google sign-in successful:", result.user.email);
    
    const userRef = doc(db, 'users', result.user.uid);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      console.log('New user detected, creating Firestore document...');
      
      const newUserData = {
        email: result.user.email,
        name: result.user.displayName || 'User',
        credits: 10,
        createdAt: serverTimestamp(),
        lastLogin: serverTimestamp(),
        photoURL: result.user.photoURL || '',
        isAdmin: false,
        invoicesProcessed: 0
      };

      try {
        await setDoc(userRef, newUserData);
        console.log('✅ New user created in Firestore with 10 credits');
      } catch (error) {
        console.error('❌ Error creating user:', error);
      }
    }
    
  } catch (error) {
    console.error("❌ Error during Google sign-in:", error);
    setLoading(false);
    
    if (error.code === 'auth/popup-blocked') {
      setProcessingError("Pop-up was blocked. Please allow pop-ups for this site.");
    } else if (error.code === 'auth/popup-closed-by-user') {
      setProcessingError("Sign-in was cancelled.");
    } else if (error.code === 'auth/cancelled-popup-request') {
      return;
    } else if (error.code === 'auth/network-request-failed') {
      setProcessingError("Network error. Please check your internet connection.");
    } else {
      setProcessingError(`Sign-in failed: ${error.message}`);
    }
  } finally {
    setLoading(false);
  }
};

export const handleLogout = async (setUser, setCredits, setPdfFile, setPdfUrl, setActiveTab, setInvoiceData) => {
  try {
    console.log('Signing out...');
    await signOut(auth);
    
    // Clear all state
    setUser(null);
    setCredits(0);
    setPdfFile(null);
    setPdfUrl(null);
    setActiveTab('invoice');
    setInvoiceData({
      'invoice-date': '',
      'invoice-number': '',
      'due-date': '',
      currency: { code: 'USD' },
      supplier: { 
        number: '',
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        email: '',
        phone: ''
      },
      customer: {
        number: '',
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        email: '',
        phone: ''
      },
      'supplier-site': { code: '' },
      'remit-to-address': { 'remit-to-code': '' },
      'ship-to-address': { id: '', 'country-code': '' },
      'requester-email': '',
      'line-level-taxation': '',
      'account-type': { name: '' },
      'payment-terms': '',
      "handling-amount": "",
      "shipping-amount": "",
      "misc-amount": "",
      "discount-amount": "",
      'default-account-code': '',
      'invoice-lines': [],
      'tax-lines': [],
      'custom-fields': { 'invoice-total': '' }
    });
    
    console.log("✅ User signed out successfully");
  } catch (error) {
    console.error('❌ Error during sign out:', error);
  }
};